<template lang="html">
  <b-row class="recommendation-block mb-2 pb-1 pt-2">
    <Info @toggleResponse="toggleResponses" @toggleFinding="toggleFindings" :recommendation="recommendation" />
    <RecommendationText :recommendation="recommendation" :showResponses="showResponses" :showFindings="showFindings"/>
  </b-row>
</template>

<script>
import Info from './miuRecommendationInfo.vue'
import RecommendationText from './miuRecommendationText.vue'
export default {
  props: ['recommendation'],
  components: {
    Info,
    RecommendationText
  },
  data() {
    return {
      showResponses: false,
      showFindings: false
    }
  },
  computed: {

  },
  methods: {
    toggleResponses(data) {
      this.showResponses = data
    },
    toggleFindings(data) {
      this.showFindings = data
    }
  }
}
</script>
<style lang="css">
.recommendation-block p {
  margin-bottom: 0.5rem;
}
</style>
<style lang="css" scoped>
.recommendation-block {
  word-wrap: break-word;
  font-size: 0.7rem;
  background-color: #F8F9FA;
  background-image: url('../../../assets/dot.png');
  background-repeat: repeat-x;
  font-family: "Nunito", Arial, sans-serif;
  page-break-after: always;
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}
</style>
